import Page from "./page.asset.admin.page";

const AssetAdminLayout = () => {
  return <Page />;
};

export default AssetAdminLayout;
